
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/settings/notification",
      function () {
        return require("private-next-pages/my/settings/notification/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/settings/notification"])
      });
    }
  